import axios from "axios";
import { socket } from "../../socket";
import { ticketSlice } from "../reducers/TicketSlice";
import { AppDispatch } from "../Store";
import {
  GET_ALL_CLOSE_TICKET,
  GET_TICKETS_BY_OPERATOR,
  TICKET_UPDATE_URL,
  FILTER_TICKETS,
  GET_ALL_OPEN_TICKET_BY_PROJECT,
  SEARCH_TICKETS_SHORT,
} from "./endpoints";
import { IMessage } from "../types/MessageTypes";
import { ITicket } from "../types/TicketTypes";
import { GET_TICKETS_BY_TELEGRAM_ID } from "./endpoints";

export const getAllOpenTickets = () => async (dispatch: AppDispatch) => {
  try {
    dispatch(ticketSlice.actions.openTicketsFetchLoading());
    await socket.emit("tickets");
  } catch (error: any) {
    dispatch(ticketSlice.actions.openTicketsFetchFailed(error.message));
  }
};

export const getAllCloseTickets =
  (status: string = "closed") =>
  async (dispatch: AppDispatch) => {
    try {
      dispatch(ticketSlice.actions.getAllCloseTicketsLoading());

      const res = await axios.get(GET_ALL_CLOSE_TICKET + `?status=${status}`, {
        withCredentials: true,
      });

      dispatch(ticketSlice.actions.getAllCloseTicketsSuccess(res.data));
    } catch (error: any) {
      dispatch(ticketSlice.actions.getAllCloseTicketsFailed(error.message));
    }
  };

const cleanParams = (obj: Record<string, any>) => {
  const out: Record<string, any> = {};
  Object.entries(obj).forEach(([k, v]) => {
    if (v === undefined || v === null) return;
    if (typeof v === "string" && v.trim() === "") return;
    out[k] = v;
  });
  return out;
};

export const filterTickets =
  (params: {
    search?: string;
    operatorId?: string;
    status?: string;
    fromDate?: string;
    toDate?: string;
    dateField?: "createdAt" | "acceptedAt" | "closedAt";
    sortBy?: string;
    order?: "asc" | "desc";
    page?: number;
    limit?: number;
  }) =>
  async (dispatch: AppDispatch) => {
    try {
      dispatch(ticketSlice.actions.getAllCloseTicketsLoading());
      const res = await axios.get(FILTER_TICKETS, {
        params: cleanParams(params),
        withCredentials: true,
      });
      dispatch(ticketSlice.actions.getAllCloseTicketsSuccess(res.data.items));
    } catch (error: any) {
      dispatch(ticketSlice.actions.getAllCloseTicketsFailed(error.message));
    }
  };

export const acceptTicket =
  (ticketId: number, operatorId: string, telegramId: string, userId: string) =>
  async (dispatch: AppDispatch) => {
    try {
      dispatch(ticketSlice.actions.addInProcessTicketLoading());
      await axios.patch(
        TICKET_UPDATE_URL + `?id=${ticketId}`,
        {
          status: "inProcess",
          operatorId: operatorId,
        },
        { withCredentials: true },
      );
    } catch (error: any) {
      dispatch(ticketSlice.actions.addInProcessTicketFailed(error.message));
    }
  };

export const getAllInProcessTickets =
  (status: string, operatorId: string) => async (dispatch: AppDispatch) => {
    try {
      dispatch(ticketSlice.actions.getAllInProcessTicketsLoading());
      const res = await axios.get(
        GET_TICKETS_BY_OPERATOR + `?status=${status}&operatorId=${operatorId}`,
        { withCredentials: true },
      );
      dispatch(ticketSlice.actions.getAllInProcessTicketsSuccess(res.data));
    } catch (error: any) {
      dispatch(ticketSlice.actions.getAllInProcessTicketsFailed(error.message));
    }
  };

export const removeInProcessTicket =
  (ticketId: number) => (dispatch: AppDispatch) => {
    try {
      dispatch(ticketSlice.actions.removeInProcessTicketLoading());
      socket.emit("close-in-process-ticket", { ticketId: ticketId });
    } catch (error: any) {
      dispatch(ticketSlice.actions.removeInProcessTicketFailed(error.message));
    }
  };

export const setLastUsersMessageTime =
  (data: { [ticketId: number]: IMessage[] }, inProcessTickets: ITicket[]) =>
  (dispatch: AppDispatch) => {
    inProcessTickets.forEach((item) => {
      const messages = data[item.id];
      if (messages !== undefined && messages.length > 1) {
        const message = messages.findLast(
          (value: IMessage) => value.userId !== null,
        );
        message !== undefined &&
          dispatch(
            ticketSlice.actions.setLastUserMessageTime({
              ticketId: item.id,
              lastUserMessageTime: message.sent_at,
            }),
          );
      } else {
        dispatch(
          ticketSlice.actions.setLastUserMessageTime({
            ticketId: item.id,
            lastUserMessageTime: item.acceptedAt!,
          }),
        );
      }
    });
  };

export const getAllOpenTicketsByProject =
  (project: string) => async (dispatch: AppDispatch) => {
    try {
      dispatch(ticketSlice.actions.getAllOpenTicketsByProjectLoading());
      const res = await axios.get(
        `${GET_ALL_OPEN_TICKET_BY_PROJECT}?project=${project}`,
        { withCredentials: true },
      );
      dispatch(ticketSlice.actions.getAllOpenTicketsByProjectSuccess(res.data));
    } catch (error: any) {
      dispatch(
        ticketSlice.actions.getAllOpenTicketsByProjectFailed(error.message),
      );
    }
  };

export const searchTicketsShort =
  (keyword: string) => async (dispatch: AppDispatch) => {
    const q = keyword.trim();

    if (!q) {
      dispatch(ticketSlice.actions.clearSearchTickets());
      return;
    }

    try {
      dispatch(ticketSlice.actions.searchTicketsLoading());

      const res = await axios.get(SEARCH_TICKETS_SHORT, {
        params: { keyword: q },
        withCredentials: true,
      });

      dispatch(ticketSlice.actions.searchTicketsSuccess(res.data || []));
    } catch (error: any) {
      dispatch(
        ticketSlice.actions.searchTicketsFailed(
          error.response?.data?.message || error.message,
        ),
      );
    }
  };

export const getTicketsByTelegramId =
  (telegramId: string) => async (dispatch: AppDispatch) => {
    try {
      dispatch(ticketSlice.actions.getUserTicketsLoading());

      const res = await axios.get(
        `${GET_TICKETS_BY_TELEGRAM_ID}?telegramId=${telegramId}`,
        { withCredentials: true },
      );

      dispatch(ticketSlice.actions.getUserTicketsSuccess(res.data));
    } catch (error: any) {
      dispatch(ticketSlice.actions.getUserTicketsFailed(error.message));
    }
  };
